import cx from 'classnames';
import { PlayStroke } from 'education-icons';
import { SimpleCallback, Text, Menu } from 'platform-components/common';
import React, { useCallback } from 'react';

import { useGetLessonRunUrl } from 'common.components/hooks';

import { b } from '../cn';

interface Props {
    onClick: SimpleCallback;
    clessonId: number;
    courseId: number;
}

export const LessonPutOnBoard = React.memo(({ onClick, clessonId, courseId }: Props) => {
    const getLessonRunUrl = useGetLessonRunUrl();
    const boardLink = getLessonRunUrl({ clessonId, courseId });

    const handlePutOnBoard = useCallback(
        (e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            e.stopPropagation();

            onClick();

            window.open(boardLink, '_blank');
        },
        [onClick, boardLink]
    );

    return (
        <Menu.Item mix={cx(b('item'), 'qa_lesson-settings-put-on-board')} onClick={handlePutOnBoard}>
            <PlayStroke className={b('control-icon')} />
            <Text id="lesson.settings.board" weight={Text.WEIGHT.S} />
        </Menu.Item>
    );
});
